<template>
  <div>
    <navlist :navlist="about" :show='false'>
    </navlist>
    <div class="layout">
      <div class="title">
        <h1>
          便民
          <br />服务
        </h1>
        
      </div>
      <div class="main">
         <h3 style="text-align:center; ">{{title}}</h3>
         <div v-html="content"></div>
      </div>
      
    </div>
  </div>
</template>

<script>
import news from "../components/news";
import navlist from "../components/nav";
import {getArticleContent} from '../api/index'
export default {
  name:'servicedetail',
  components: {
    navlist,
    news
  },
  data() {
    return {
      about: [
       {
          path: "/service",
          name: "便民服务"
        }
      ],
      id:this.$route.params.id,
      local: "",
      content:'',
      title:''
    };
  },
  watch:{
    $route(to){
      console.log(to)
      this.id= to.params.id
      this.getContent()
    }
  },
  created() {
    //console.log(this.$route)
    this.getContent()
  },
  watch: {
  },
  methods: {
    async getContent(){
      this.content = ''
      let {id} =this
      let {data} = await getArticleContent({id}) 
      this.content = data.data.content
      this.title = data.data.title
    }
  }
};
</script>

<style>
.width {
  width: 1380px;
  margin-top: 20px !important;
}
</style>